"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaintType = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("../../../editor/theme");
const index_1 = require("../../../GraphQL/Compile/index");
exports.PaintType = ({ type }) => {
    let compiledType = index_1.compileTypeOptions({ type });
    return (react_1.default.createElement("span", { style: { color: type.name in theme_1.GraphQLColors ? theme_1.GraphQLColors[type.name] : '#fff' } }, compiledType));
};
